"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var core_1 = require("@material-ui/core");
var Icon_1 = require("./Icon");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var classnames_1 = require("classnames");
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            display: 'flex',
        },
        drawer: {
            width: function (props) { return props.drawerWidth; },
            overflowX: 'hidden',
            boxShadow: theme.shadows[8],
        },
        desktopDrawerOpen: {
            width: function (props) { return props.drawerWidth; },
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        desktopDrawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: function () { return '3rem'; },
        },
        appBarContent: {
            marginLeft: 50,
        },
        drawerHeader: {
            display: 'flex',
            minHeight: '4rem',
            alignItems: 'center',
        },
        drawerButton: {
            marginLeft: 3,
        },
        drawerLogo: {
            marginLeft: 9,
        },
        appBarLogo: {
            marginLeft: 25,
        },
        menuButton: {
            width: 40,
            height: 40,
            fontSize: '1rem',
            visibility: function (_a) {
                var drawer = _a.drawer;
                return (drawer ? 'visible' : 'hidden');
            },
        },
        drawerContainer: (_a = {},
            _a[theme.breakpoints.up('sm')] = {
                width: function (props) { return props.drawerWidth; },
                overflow: 'hidden',
            },
            _a),
        mobileDrawerPaper: {
            paddingRight: '1rem',
        },
    });
});
var AppDrawer = function (props) {
    var _a, _b;
    var drawer = props.drawer, appBar = props.appBar, appBarBottom = props.appBarBottom, drawerOpen = props.drawerOpen, onDrawerOpenChange = props.onDrawerOpenChange, logo = props.logo, _c = props.classNames, classNames = _c === void 0 ? {} : _c;
    var theme = core_1.useTheme();
    var classes = useStyles(__assign({ drawerWidth: 240 }, props));
    var handleDrawerToggle = function () {
        onDrawerOpenChange(!drawerOpen);
    };
    var drawerContainer = (React.createElement("div", { className: classes.drawerContainer },
        React.createElement("div", { className: classes.drawerHeader },
            React.createElement(core_1.IconButton, { className: classnames_1.default(classes.drawerButton, classes.menuButton), onClick: handleDrawerToggle },
                React.createElement(core_1.Hidden, { smUp: true },
                    React.createElement(Icon_1.default, { icon: drawerOpen ? pro_light_svg_icons_1.faTimes : pro_light_svg_icons_1.faBars })),
                React.createElement(core_1.Hidden, { xsDown: true },
                    React.createElement(Icon_1.default, { icon: drawerOpen ? pro_light_svg_icons_1.faChevronLeft : pro_light_svg_icons_1.faBars }))),
            React.createElement("div", { className: classes.drawerLogo }, drawerOpen && logo)),
        drawer));
    return (React.createElement("div", { className: classes.root },
        React.createElement(core_1.AppBar, { position: "fixed", color: "inherit", className: classNames.appBar },
            React.createElement(core_1.Toolbar, null,
                React.createElement(core_1.IconButton, { edge: "start", onClick: handleDrawerToggle, className: classes.menuButton },
                    React.createElement(Icon_1.default, { icon: pro_light_svg_icons_1.faBars })),
                React.createElement("div", { className: classnames_1.default(classes.appBarLogo, classNames.appBarLogo) }, logo),
                React.createElement("div", { className: classnames_1.default(classes.appBarContent, classNames.appBarContent) }, appBar)),
            appBarBottom),
        React.createElement("nav", null,
            React.createElement(core_1.Hidden, { smUp: true, implementation: "js" }, drawer && (React.createElement(core_1.Drawer, { variant: "temporary", anchor: theme.direction === 'rtl' ? 'right' : 'left', open: drawerOpen, onClose: handleDrawerToggle, ModalProps: {
                    keepMounted: true,
                }, classes: {
                    paper: classes.mobileDrawerPaper,
                }, className: classes.drawer }, drawerContainer))),
            React.createElement(core_1.Hidden, { xsDown: true, implementation: "css" }, drawer && (React.createElement(core_1.Drawer, { className: classnames_1.default(classes.drawer, (_a = {},
                    _a[classes.desktopDrawerOpen] = drawerOpen,
                    _a[classes.desktopDrawerClose] = !drawerOpen,
                    _a)), classes: {
                    paper: classnames_1.default(classes.drawer, (_b = {},
                        _b[classes.desktopDrawerOpen] = drawerOpen,
                        _b[classes.desktopDrawerClose] = !drawerOpen,
                        _b)),
                }, variant: "permanent", open: true }, drawerContainer))))));
};
exports.default = AppDrawer;
//# sourceMappingURL=AppNavigation.js.map